import React, { useCallback, useEffect, useState } from "react";
import { Redirect, withRouter } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import Footer from "./shared/Footer";
import { withTranslation } from "react-i18next";

// ----------------------------------------------------------
// import filepond
import { registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
// import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFilePoster from "filepond-plugin-file-poster";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css";
import HttpService from "../services/HttpService";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  //FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType,
  FilePondPluginFilePoster
);

const isFullPageLayoutCheck = (path) => {
  if (path === "/login" || path === "/reset-password") {
    return true;
  }

  if (path.startsWith("/billing/setup/")) {
    return true;
  }

  return false;
};

function App(props) {
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);
  const [redirectToLogin, setRedirectToLogin] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkUserAuth = useCallback(() => {
    HttpService.get("/auth/validate")
      .then((response) => response.json())
      .then((response) => {
        if (response.status === "fail") {
          setRedirectToLogin(true);
        }

        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      HttpService.setDefaultHeader("Authorization", `Bearer ${accessToken}`);
      checkUserAuth();
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (loading) {
      return;
    }

    const dom = document.querySelector(".page-body-wrapper");

    if (isFullPageLayoutCheck(props.location.pathname)) {
      setIsFullPageLayout(true);
      dom.classList.add("full-page-wrapper");
    } else {
      setIsFullPageLayout(false);
      dom.classList.remove("full-page-wrapper");
    }
  }, [loading, props.location]);

  if (loading) {
    return "Loading ...";
  }

  if (
    redirectToLogin &&
    window.location.pathname !== "/login" &&
    !window.location.pathname.startsWith("/billing/setup/")
  ) {
    window.location.href = "/login";
    return null;
  }

  const navbarComponent = !isFullPageLayout ? <Navbar /> : null;
  const sidebarComponent = !isFullPageLayout ? <Sidebar /> : null;
  const footerComponent = !isFullPageLayout ? <Footer /> : null;

  return (
    <div className="container-scroller">
      {sidebarComponent}
      <div className="container-fluid page-body-wrapper">
        {navbarComponent}
        <div className="main-panel">
          <div className="content-wrapper">
            <AppRoutes />
          </div>
          {footerComponent}
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(withRouter(App));
